import React from 'react';
import './cs.css';

function BoostSales() {
    
  return (
    
    <div className="coming-soon-container">
      <div className="coming-soon-content">
        <p className="new">Coming Soon!</p>
        <p>We're working hard to launch our new website.</p>
        <p>Stay tuned for updates!</p>
        <div className="countdown-container">
          <Countdown />
        </div>
      </div>
    </div>
  );
}

function Countdown() {
  const [days, setDays] = React.useState(30);
  const [hours, setHours] = React.useState(0);
  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);

  React.useEffect(() => {
    const countdownInterval = setInterval(() => {
      const now = new Date().getTime();
      const launchDate = new Date('2024-09-25T00:00:00.000Z').getTime();
      const timeDiff = launchDate - now;

      const daysLeft = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hoursLeft = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutesLeft = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const secondsLeft = Math.floor((timeDiff % (1000 * 60)) / 1000);

      setDays(daysLeft);
      setHours(hoursLeft);
      setMinutes(minutesLeft);
      setSeconds(secondsLeft);
    }, 1000);

    return () => clearInterval(countdownInterval);
  }, []);

  return (
    <div className="countdown">
      <div className="countdown-item">
        <span>{days}</span>
        <p>Days</p>
      </div>
      <div className="countdown-item">
        <span>{hours}</span>
        <p>Hours</p>
      </div>
      <div className="countdown-item">
        <span>{minutes}</span>
        <p>Minutes</p>
      </div>
      <div className="countdown-item">
        <span>{seconds}</span>
        <p>Seconds</p>
      </div>
    </div>
  );
}

export default BoostSales;